import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box,
  Radio
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  dateFormatter,
  dropdownFetch,
  formatDate,
  getCurrentDateTime,
  getKeyPathValue,
  request,
  toast
} from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { RECEIPT_MODE, BANK_CASH_INDENT_MEDICINE_ISSUE } from '../../../../../constants/dropdown';
import { MedicineEditForm } from './MedicineEditForm';

const TAX_HEADER = [
  { header: 'GST%', accessor: 'gst' || 0 },
  { header: 'Taxable Amt', accessor: 'taxable_amount' || 0 },
  { header: 'CGST Amt', accessor: 'cgst' || 0 },
  { header: 'SGST Amt', accessor: 'sgst' || 0 }
];

const POS_HEADER = [
  {
    header: 'Issue Type',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.issue_type}`}
        </span>
      );
    }
  },
  { header: 'Issue No.', accessor: 'issue_no' },
  { header: 'Issue Date', accessor: (row) => formatDate(row?.date) },
  { header: 'Indent No', accessor: 'indent_no' },
  { header: 'Indent Date', accessor: (row) => formatDate(row?.indent_date) },
  { header: 'To Organisation', accessor: 'indent_by' },
  { header: 'Uhid', accessor: 'uhid' },
  { header: 'Adm No', accessor: 'ipd_no' },
  { header: 'Patient Name', accessor: 'patient_name' },
  { header: 'Paymode', accessor: 'pay_mode' },
  { header: 'Net Amount', accessor: 'total_amt' }
];

const OPD_INDENT_TABLE_COLUMNS = [
  { header: 'Indent No.', accessor: (row) => row?.indent_no },
  { header: 'Adm No', accessor: (row) => row?.ipd_no },
  { header: 'Uhid', accessor: (row) => row?.uhid },
  {
    header: 'Patient Name',
    accessor: (row) => `${row.patient?.name_suffix}${row.patient?.first_name}${row?.patient?.last_name}`
  }
];

const IPD_INDENT_TABLE_COLUMNS = [
  { header: 'Indent No.', accessor: (row) => row?.indent_no },
  { header: 'Adm No', accessor: (row) => row?.ipd_no },
  { header: 'Uhid', accessor: (row) => row?.uhid },
  {
    header: 'Patient Name',
    accessor: (row) => `${row.patient?.name_suffix}${row.patient?.first_name}${row?.patient?.last_name}`
  }
];

function getMonthYear(dateString) {
  const date = new Date(dateString);
  const options = { year: 'numeric', month: '2-digit' };
  return date.toLocaleDateString('en-GB', options);
}

const initialPatientDataObj = {
  data: [],
  loading: false
};
const initialPosDataObj = {
  data: [],
  loading: false
};
export const IndoorMedicineReturn = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [patientDataObj, setPatientDataObj] = useState(initialPatientDataObj);
  const [retailSalePosObj, setRetailSalePosObj] = useState(initialPosDataObj);
  const [indoorRegisterationDataObj, setIndoorRegisterationDataObj] = useState(initialPatientDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [input, setInput] = useState('');
  const [warehouse, setWareHosue] = useState([]);
  const [patientDetail, setPatientDetail] = useState([]);
  const [addDetailsDialogue, setAddDetailsDialogOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [qty, setQty] = useState('');
  const [opdData, setOpdData] = useState([]);
  const [ipdData, setIpdData] = useState([]);
  const [indentMedicineInput, setIndentMedicineInput] = useState('');
  const [opdInput, setOpdInput] = useState('');
  const [ipdInput, setIpdInput] = useState('');
  const [productList, setProductList] = useState([]);
  const [taxTableData, setTaxTableData] = useState([{ gst: 0, bill_amount: 0, cgst: 0, sgst: 0 }]);
  const [posData, setPosData] = useState([]);
  const [opdFilterData, setOpdFilterData] = useState({ data: [] });
  const [ipdFilterData, setIpdFilterData] = useState({ data: [] });
  const productRef = useRef();
  const billAmountRef = useRef(null);
  const gstAmountRef = useRef(null);
  const cgstAmountRef = useRef(null);
  const sgstAmountRef = useRef(null);
  const [selectedRadio, setSelectedRadio] = useState('ipd_indent');
  const [doctorDropdown, setDoctorDropdown] = useState([]);
  const [roomMasterDropdown, setRoomMasterDropdown] = useState([]);
  const [sponsorDropdown, setSponsorDropdown] = useState([]);
  const [medicineData, setMedicineData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [originalOpdData, setOriginalOpdData] = useState([]);
  const [isFiltered, setIsFiltered] = useState([]);
  const [originalMedicineIssue, setOriginalMedicineIssue] = useState([]);
  const [stockProduct, setStockProduct] = useState([]);
  const [filteredServiceList, setFilteredServiceList] = useState([]);


    useEffect(() => {
    const taxMap = {};
    medicineData.forEach(item => {
      const { gst, quantity, rate } = item;
      const total = quantity * rate;
      const taxableAmount = total;
      const cgst = (taxableAmount * gst) / 200;
      const sgst = (taxableAmount * gst) / 200;
      if (taxMap[gst]) {
        taxMap[gst].taxable_amount += taxableAmount;
        taxMap[gst].cgst += cgst;
        taxMap[gst].sgst += sgst;
      } else {
        taxMap[gst] = {
          gst,
          taxable_amount: taxableAmount,
          cgst,
          sgst
        };
      }
    });
    const newTaxTableData = Object.values(taxMap).map(item => ({
      gst: item.gst,
      taxable_amount: Number(item.taxable_amount.toFixed(2)-(Number(item.taxable_amount)*Number(item.gst)/100)),
      cgst: Number(item.cgst.toFixed(2)),
      sgst: Number(item.sgst.toFixed(2))
    }));

    setTaxTableData(newTaxTableData);
  }, [medicineData]);

  const user = JSON.parse(localStorage.getItem('user'));
  const [productStock, setProductStock] = useState([]);
  const { getValues } = useForm();
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        location: Yup.string().required(' '),
        pay_mode: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
      product_type: 'pharmacy product',
      bill: {
        out_sourced: 'No',
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;


  const TotalAmount = watch('total_amt');
  const DisPercent = watch('dis_per');
  const DisAmt = watch('dis_amount');
  const recAmt1Watch = watch('recpt_1');
  const recAmt2Watch = watch('recpt_2');
  const taxable = watch('bill_amount');
  const gstPer = watch('gst');
  const cgst = watch('cgst');
  const sgst = watch('sgst');

useEffect(() => {
  let totalTaxable = 0;
  let totalCgst = 0;
  let totalSgst = 0;
  taxTableData.forEach(item => {
    totalTaxable += +item.taxable_amount || 0;
    totalCgst += +item.cgst || 0;
    totalSgst += +item.sgst || 0;
  });
  const totalGst = totalCgst + totalSgst;
  const grossAmount = totalTaxable + totalGst;
  setValue('total_amt', +grossAmount);
  setValue('cgst', +totalCgst.toFixed(2));
  setValue('sgst', +totalSgst.toFixed(2));
    setValue('gst',totalGst)
  setValue('bill_amount', +totalTaxable.toFixed(2));
  const totalRecpt = (+recAmt1Watch || 0) + (+recAmt2Watch || 0);
  setValue('total_recpt', +totalRecpt.toFixed(2));
  const balance = grossAmount - totalRecpt;
  setValue('balance', +balance.toFixed(2));
}, [taxTableData, recAmt1Watch, recAmt2Watch, setValue]);


  const netAmtWatch = watch('total_amt');
  const payMode = watch('pay_mode');

useEffect(() => {
  const total_recpt = (+recAmt1Watch || 0) + (+recAmt2Watch || 0);
  const netAmount = watch('bill_amount'); 
  const balanceAmt = netAmount - total_recpt;

  if (payMode === 'CASH') {
    setValue('recpt_1', netAmount);
    setValue('recpt_2', 0);
    setValue('balance', 0);
  } else if (['Bank', 'UPI', 'Paytm', 'RTGS/NEFT/Cheque', 'Credit Card', 'Debit Card'].includes(payMode)) {
    setValue('recpt_1', 0);
    setValue('recpt_2', netAmount);
    setValue('balance', 0);
  } else if (payMode === 'Credit') {
    setValue('recpt_1', 0);
    setValue('recpt_2', 0);
    setValue('balance', netAmount);
  } else {
    setValue('balance', balanceAmt);
  }
}, [payMode, recAmt1Watch, recAmt2Watch, setValue]);
  const formSubmit = async (formValues) => {
    if (medicineData.length === 0) {
      toast('Please add the Medicine Data', { variant: 'warning' });
      return;
    }
    setLoading(true);
    const productData = medicineData.map((row) => ({
      ...row,
      amount: row.rate * row.bill_qty
    }));
    const payload = {
      ...formValues,
      productDetails: productData,
      taxDetails: taxTableData,
      issue_type: selectedRadio
    };
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/indoor-medicine-return-update' : '/indoor-medicine-return-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...payload,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });

    if (response?.success && response.data) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} Indent Medicine Issue`, { variant: 'success' });
      setSelectedRecord(response?.data);
      setCurrentAction();
      fetchIpdPatient();
      fetchOpdPatients();
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} Indent Medicine Issue`, { variant: 'error' });
    }

    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setRetailSalePosObj({ loading: true });
    const response = await request('/indoor-medicine-return-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setRetailSalePosObj({ loading: false, data: filteredData });
      setPosData({ data: response.data });
    } else {
      toast('Failed to load Retail Sale list', { variant: 'error' });
      setRetailSalePosObj({ loading: false });
    }
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/retail-sale-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully cancel Retail Sale Pos', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel Retail Sale Pos', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/retail-sale-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Retail Sale Pos', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Retail Sale Pos', { variant: 'error' });
    }
    setLoading(false);
  };

  const getDoctorDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor');
    if (!selectedRecord && !getValues('consultant')) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('consultant', defaultState?._id);
      if (defaultState) {
        setValue('department', defaultState.qualification_details.department);
      }
    }

    setDoctorDropdown(data);
  }, [selectedRecord, getValues, setValue]);

  const getLocationDropdown = useCallback(async () => {
    const data = await dropdownFetch('warehouse');
    if (!selectedRecord) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('location', defaultState?._id);
    }
    setWareHosue(data);
  }, []);

  const getStockDropdown = useCallback(async () => {
    const data = await dropdownFetch('stock-master');
    setProductStock(data);
  }, []);

  const getRoomMasterDropdown = useCallback(async () => {
    const data = await dropdownFetch('room-master');
    setRoomMasterDropdown(data);
  }, []);

  const getSponsorDropdown = useCallback(async () => {
    const data = await dropdownFetch('sponsor');
    setSponsorDropdown(data);
  }, []);

  const getProductDropdown = useCallback(async () => {
    const data = await dropdownFetch('stock-master');
    setStockProduct(data);
    setFilteredServiceList(data);
  }, []);

  useEffect(() => {
    getProductDropdown();
  }, [getProductDropdown]);

  useEffect(() => {
    getLocationDropdown();
    getStockDropdown();
    getLocationDropdown();
    getDoctorDropdown();
    getRoomMasterDropdown();
    getSponsorDropdown();
  }, [getStockDropdown, getLocationDropdown, getDoctorDropdown, getRoomMasterDropdown, getSponsorDropdown]);

  console.log('HELLLO STOCK MASTER DATA', productStock);

  const calculateAge = (dob) => {
    // Parse the date of birth
    const birthDate = new Date(dob);
    const today = new Date();

    // Calculate year difference
    let age = today.getFullYear() - birthDate.getFullYear();

    // Adjust if the birthday hasn't occurred yet this year
    const monthDifference = today.getMonth() - birthDate.getMonth();
    const dayDifference = today.getDate() - birthDate.getDate();
    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }

    return age;
  };

  const handleRowClick = (row) => {
    console.log('HELLLO ROW', row);
    // Initialize medicineData with row items
    const medicineData = row.items;
    // Iterate through each item in medicineData
    const updatedMedicineData = medicineData.map((medicineItem) => {
      // Find matching product in productStock
      const matchedProduct = productStock.find((product) =>
        product.productDetails.some((detail) => detail.product._id === medicineItem.medicine)
      );
      // If a matching product is found, get additional details
      if (matchedProduct) {
        const productDetail = matchedProduct.productDetails.find(
          (detail) => detail.product._id === medicineItem.medicine
        );

        // Add additional information to medicineItem
        return {
          ...medicineItem,
          batch_no: productDetail.batch_no,
          rate: productDetail.rate,
          gst: productDetail.gst,
          exp_date: productDetail.exp_date,
          _id: productDetail.medicine
        };
      }
      // Return the medicine item unchanged if no match found
      return medicineItem;
    });
    // Update the state with the modified medicine data
    setMedicineData(updatedMedicineData);
    // Set other form values as per your function logic
    setValue('consultant', row?.patientIpdInfo?.consultant_detail?.doctor);
    setValue('patient_name', `${row?.patient?.name_suffix}${row?.patient?.first_name}${row?.patient?.last_name}`);
    setValue('gender', row?.patient?.gender);
    const formattedRegDate = row?.date ? new Date(row.date).toISOString().split('T')[0] : '';
    setValue('indent_date', formattedRegDate);
    setValue('indent_no', row?.indent_no);
    setValue('age', calculateAge(row?.patient?.dob));
    setValue('sponsor', row?.patientInfo?.sponsor);
    setValue('uhid', row?.uhid);
    setValue('ipd_no', row?.ipd_no);
    setValue('indent_by', user.name);
    setValue('room', row?.patientIpdInfo?.consultant_detail?.room);
    setValue('ward', row?.wardInfo?.name);
  };

  const handleRowOPDClick = (row) => {
    console.log('HELLLO ROW', row);
    // Initialize medicineData with row items
    const medicineData = row.items;
    // Iterate through each item in medicineData
    const updatedMedicineData = medicineData.map((medicineItem) => {
      // Find matching product in productStock
      const matchedProduct = productStock.find((product) =>
        product.productDetails.some((detail) => detail.product._id === medicineItem.medicine)
      );
      // If a matching product is found, get additional details
      if (matchedProduct) {
        const productDetail = matchedProduct.productDetails.find(
          (detail) => detail.product._id === medicineItem.medicine
        );

        // Add additional information to medicineItem
        return {
          ...medicineItem,
          batch_no: productDetail.batch_no,
          rate: productDetail.rate,
          gst: productDetail.gst,
          exp_date: productDetail.exp_date,
          _id: productDetail.medicine
        };
      }
      // Return the medicine item unchanged if no match found
      return medicineItem;
    });
    // Update the state with the modified medicine data
    setMedicineData(updatedMedicineData);
    // Set other form values as per your function logic
    setValue('consultant', row?.patientInfo?.consultant);
    const formattedRegDate = row?.date ? new Date(row.date).toISOString().split('T')[0] : '';
    setValue('indent_date', formattedRegDate);
    setValue('patient_name', `${row?.patient?.name_suffix}${row?.patient?.first_name}${row?.patient?.last_name} `);
    setValue('gender', `${row?.patient?.gender}`);
    setValue('age', calculateAge(row?.patient?.dob));
    setValue('sponsor', row?.patient?.sponsor);
    setValue('uhid', row?.uhid);
    setValue('indent_by', user.name);
    setValue('room', row?.patientIpdInfo?.consultant_detail?.room);
    setValue('ward', row?.wardInfo?.name);
  };

  const handleQtyChange = (e) => {
    setQty(e.target.value);
  };

  const fetchOpdPatients = useCallback(async () => {
    setPatientDataObj({ loading: true });
    try {
      const response = await request('/indent-medicine-returns-lists', { method: 'GET' });
      if (response.success) {
        const filteredData = response.data.filter(
          (item) => item.authorize === true && item.indent_type === 'MR' && item.patient_type === 'opd_indent'
        );
        setPatientDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching indent list data', { variant: 'error' });
        setPatientDataObj({ loading: false });
      }
    } catch (error) {
      console.error('Error fetching patient data:', error);
      toast('Error in fetching data', { variant: 'error' });
      setPatientDataObj({ loading: false });
    }
  }, []);

  const fetchIpdPatient = useCallback(async () => {
    setIndoorRegisterationDataObj({ loading: true });
    try {
      const response = await request('/indent-medicine-returns-lists', { method: 'GET' });
      if (response.success) {
        const filteredData = response.data.filter(
          (item) => item.authorize === true && item.indent_type === 'MR' && item.patient_type === 'ipd_indent'
        );
        setIndoorRegisterationDataObj({ loading: false, data: filteredData });
        console.log('Indoor Registration Data Obj:', filteredData);
      } else {
        toast('Error in fetching indent list data', { variant: 'error' });
        setIndoorRegisterationDataObj({ loading: false });
      }
    } catch (error) {
      console.error('Error fetching IPD patient data:', error);
      toast('Error in fetching data', { variant: 'error' });
      setIndoorRegisterationDataObj({ loading: false });
    }
  }, []);

  useEffect(() => {
    fetchIpdPatient();
    fetchOpdPatients();
  }, [fetchIpdPatient, fetchOpdPatients]);

  useEffect(() => {
    if (productRef.current) {
      productRef.current.focus();
    }
  }, []);

  const productData = tableData.map((row) => ({
    ...row,
    amount: row.rate * row.bill_qty
  }));

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  const PRODUCT_TABLE_HEADER = [
    { header: 'Requested Medicine', accessor: (row) => row?.medicineDetails?.name?.main?.name },
    { header: 'Indent Qty', accessor: 'quantity' },
    { header: 'Return Medicine Name', accessor:(row)=> row?.product_name|| row?.
      productMasterDetails
      ?.name?.main?.name  },
    {
      header: 'Return Qty',
      accessor: 'quantity'
    },
    { header: 'Rate', accessor: 'rate' },
    { header: 'Net Amount', accessor: (row) => row?.amount || row.rate * row.quantity },
    { header: 'Batch No', accessor: 'batch_no' },
    { header: 'Exp Date', accessor: (row) => getMonthYear(row?.exp_date) }
  ];

  const handleRadioChange = (event) => {
    const { name } = event.target;
    setSelectedRadio(name);
  };

  const handleEditClick = (row) => {
    console.log('HELLLO ROWS', row);
    setAddDetailsDialogOpen(true);
  };

  const onDetailAddHandler = (formValues) => {
    // Find the matching product from the productStock using the product id
    const matchedProduct = productStock.find(
      (item) => item.productDetails[0].product._id.toString() === formValues.product.toString()
    );

    // If a matching product is found, extract the product name (main.name)
    const productName = matchedProduct ? matchedProduct.productDetails[0].product.main.name : null;

    const newMedicineData = {
      _id: formValues.product,
      product: formValues.product,
      batch_no: formValues.batch_no,
      exp_date: formValues.exp_date,
      gst: formValues.gst,
      quantity: formValues.bill_qty,
      rate: formValues.rate,
      amount: formValues.amount,
      gst_percentage: formValues.gst,
      product_name: productName // Set the product name if matched
    };

    setMedicineData((prevData) => {
      // Check if there's any item with the same _id
      const existingItemIndex = prevData.findIndex((item) => item._id === newMedicineData._id);

      if (existingItemIndex !== -1) {
        // If an item with the same _id exists, do nothing
        return prevData;
      }

      // Find the first row where the _id is different and hasn't been modified yet
      const firstUnmatchedIndex = prevData.findIndex((item, index) => {
        return item._id !== newMedicineData._id && !item.modified;
      });

      if (firstUnmatchedIndex !== -1) {
        // Update the unmatched row and mark it as modified
        const updatedData = [...prevData];
        updatedData[firstUnmatchedIndex] = {
          ...updatedData[firstUnmatchedIndex],
          ...newMedicineData,
          modified: true // Add a 'modified' flag to mark the row as updated
        };
        return updatedData; // Return the updated list
      }

      // If no unmatched row is found, do nothing and return the original data
      return prevData;
    });
  };

  useEffect(() => {
    if (
      indoorRegisterationDataObj &&
      Array.isArray(indoorRegisterationDataObj.data) &&
      indoorRegisterationDataObj.data.length > 0
    ) {
      setOriginalData(indoorRegisterationDataObj.data);
      setIsFiltered(false);
    }
  }, [indoorRegisterationDataObj.data]);

  useEffect(() => {
    if (patientDataObj && Array.isArray(patientDataObj.data) && patientDataObj.data.length > 0) {
      setOriginalOpdData(patientDataObj.data);
      setIsFiltered(false);
    }
  }, [patientDataObj.data]);

  useEffect(() => {
    handlePatientSearch(input);
    handleOpdPatientSearch(input);
  }, [input]);

  const handlePatientSearch = (searchInput) => {
    if (Array.isArray(indoorRegisterationDataObj.data)) {
      const lowercasedInput = searchInput.toLowerCase();
      const filtered = indoorRegisterationDataObj.data.filter((item) =>
        item.indent_no.toString().toLowerCase().includes(lowercasedInput)
      );
      setOriginalData(filtered);
      setIsFiltered(true);
    }
  };

  const handleOpdPatientSearch = (searchInput) => {
    if (Array.isArray(patientDataObj.data)) {
      const lowercasedInput = searchInput.toLowerCase();
      const filtered = patientDataObj.data.filter((item) =>
        item.indent_no.toString().toLowerCase().includes(lowercasedInput)
      );
      setOriginalOpdData(filtered);
      setIsFiltered(true);
    }
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  useEffect(() => {
    if (posData && Array.isArray(posData.data) && posData.data.length > 0) {
      setOriginalMedicineIssue(posData.data);
      setIsFiltered(false);
    }
  }, [posData.data]);

  useEffect(() => {
    handleIndentMedicine(indentMedicineInput);
  }, [indentMedicineInput]);

  const handleIndentMedicine = (searchInput) => {
    if (Array.isArray(posData.data)) {
      const lowercasedInput = searchInput.toLowerCase();
      const filtered = posData.data.filter((item) => item.issue_no.toString().toLowerCase().includes(lowercasedInput));
      setOriginalMedicineIssue(filtered);
      setIsFiltered(true);
    }
  };

  const handleIndentMedicineQuery = (e) => {
    const newInput = e.target.value;
    setIndentMedicineInput(newInput);
  };

  
      useEffect(() => {
        if (selectedRecord) {
          setMedicineData(selectedRecord?.productDetails);
          setValue('issue_no',selectedRecord?.issue_no)
          setValue('total_amt',selectedRecord?.total_amt)
          setValue('recpt_1',selectedRecord?.recpt_1)
          setValue('recpt_2',selectedRecord?.recpt_2)
          setValue('indent_by',selectedRecord?.indent_by)
          setValue('uhid',selectedRecord?.uhid)
          setValue('ipd_no',selectedRecord?.ipd_no)
          setValue('patient_name', `${selectedRecord?.patient?.name_suffix} ${selectedRecord?.patient?.first_name} ${selectedRecord?.patient?.last_name}`)
          setValue('gender', selectedRecord?.patient?.gender)
          setValue('age', calculateAge(selectedRecord?.patient?.dob))
          setValue('consultant',(selectedRecord?.patientIpdInfo?.consultant_detail?.doctor))
          setValue('sponsor',(selectedRecord?.patientInfo?.sponsorInfo?._id))
          setValue('pay_mode',(selectedRecord?.pay_mode))
          setValue('remarks',selectedRecord?.remarks)
          setValue('ref_no',selectedRecord?.ref_no)
          setValue('indent_no',selectedRecord?.indent_no)
          setValue('ward',selectedRecord?.wardInfo?.name)
        } else {
          reset();
        }
      }, [selectedRecord]);
  
  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Indoor Medicine Return
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([]);
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={3.5} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    {/* <Radio
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{
                        flex: 0.6,
                        border: currentAction ? '0.5px solid red' : '',
                        backgroundColor: currentAction ? '#B3E5FC' : ''
                      }}
                      name="opd_indent"
                      checked={selectedRadio === 'opd_indent'}
                      onChange={handleRadioChange}
                    />
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Opd Indent</Typography> */}
                    <Radio
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{
                        flex: 0.6,
                        border: currentAction ? '0.5px solid red' : '',
                        backgroundColor: currentAction ? '#B3E5FC' : ''
                      }}
                      name="ipd_indent"
                      checked={selectedRadio === 'ipd_indent'}
                      onChange={handleRadioChange}
                    />
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Ipd Indent</Typography>
                  </Stack>
                  <Grid item sx={{ display: 'flex', flexDirection: 'column', minHeight: '40rem', marginTop: '1%' }}>
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
                      <MuiTextField
                        sx={{
                          width: '100%',
                          '& .MuiOutlinedInput-root': {
                            padding: '0',
                            fontSize: '16px',
                            fontWeight: '700'
                          },
                          '& .MuiOutlinedInput-input': {
                            padding: '8px 14px'
                          }
                        }}
                        label="Search Patient"
                        onChange={handleChange}
                        variant="outlined"
                        value={input}
                        inputRef={productRef}
                      />
                    </Stack>
                    {selectedRadio === 'ipd_indent' ? (
                      <Table
                        containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)', minHeight: '40rem' }}
                        data={currentAction === 'new' ? originalData : []}
                        columns={IPD_INDENT_TABLE_COLUMNS}
                        size="small"
                        onRowClick={(row) => {
                          handleRowClick(row);
                        }}
                      />
                    ) : (
                      <Table
                        containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)', minHeight: '40rem' }}
                        data={currentAction === 'new' ? originalOpdData : []}
                        columns={OPD_INDENT_TABLE_COLUMNS}
                        onRowClick={(row) => {
                          handleRowOPDClick(row);
                        }}
                        size="small"
                      />
                    )}
                  </Grid>
                  <Grid item sx={{ display: 'flex', flexDirection: 'column', minHeight: '6rem' }}>
                    <Table
                      containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                      data={taxTableData || []}
                      columns={TAX_HEADER}
                      size="small"
                    />
                  </Grid>
                </Grid>
                <Grid item xs={8.5} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack
                    sx={{ border: '0px solid grey', padding: '5px', borderRadius: '5px' }}
                    spacing={0.5}
                    direction="row"
                  >
                    <Grid
                      item
                      xs={4}
                      sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, boxShadow: '0px 2px 2px #0099ff' }}
                    >
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Return No.</Typography>
                        <TextField
                          disabled
                          sx={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : '',
                            backgroundColor: currentAction ? '#B3E5FC' : ''
                          }}
                          name="return_no"
                          placeholder="Return No."
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>To Org</Typography>
                        <TextField
                          disabled
                          sx={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : '',
                            backgroundColor: currentAction ? '#B3E5FC' : ''
                          }}
                          name="to_org"
                          placeholder="To Org"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Uhid/Ipd No.</Typography>
                        <TextField disabled sx={{ flex: 0.4 }} name="uhid" placeholder="Uhid" />
                        <TextField disabled sx={{ flex: 0.4 }} name="ipd_no" placeholder="Ipd No" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Sponsor</Typography>
                        <SelectTag
                          disabled
                          formControlSX={{ flex: 0.8 }}
                          name="sponsor"
                          menus={sponsorDropdown}
                          placeholder="Sponsor"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Pay Mode</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.8 }}
                          name="pay_mode"
                          placeholder="Pay Mode"
                          menus={RECEIPT_MODE}
                        />
                      </Stack>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, boxShadow: '0px 2px 2px #0099ff' }}
                    >
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Date/Time</Typography>
                        <TextField disabled sx={{ flex: 0.4 }} name="date" type="date" />
                        <TextField
                          disabled
                          sx={{ flex: 0.4, border: currentAction ? '0.5px solid red' : '' }}
                          name="time"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Location</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.8 }}
                          name="location"
                          placeholder="Select Location"
                          menus={warehouse.map((data) => ({ ...data, name: data.warehouse_name }))}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Patient Name</Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="patient_name" placeholder="Patient Name" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Consultant</Typography>
                        <SelectTag disabled formControlSX={{ flex: 0.8 }} name="consultant" menus={doctorDropdown} />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Bank/Cash</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.8 }}
                          name="bank_cash"
                          menus={BANK_CASH_INDENT_MEDICINE_ISSUE}
                        />
                      </Stack>
                    </Grid>

                    <Grid
                      item
                      xs={4}
                      sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, boxShadow: '0px 2px 2px #0099ff' }}
                    >
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Indent No/Date</Typography>
                        <TextField disabled sx={{ flex: 0.4 }} name="indent_no" />
                        <TextField disabled sx={{ flex: 0.4 }} name="indent_date" type="date" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Indent By</Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="indent_by" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Gender/Age</Typography>
                        <TextField disabled sx={{ flex: 0.4 }} name="gender" placeholder="Gender" />
                        <TextField disabled sx={{ flex: 0.4 }} name="age" placeholder="Age" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Ward/Room</Typography>
                        <TextField disabled sx={{ flex: 0.4 }} name="ward" placeholder="Ward" />
                        <SelectTag
                          disabled
                          formControlSX={{ flex: 0.4 }}
                          name="room"
                          menus={roomMasterDropdown.map((data) => ({ ...data, name: data.room_no }))}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Remarks</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8 }}
                          name="remarks"
                        />
                      </Stack>
                    </Grid>
                  </Stack>
                  <Table
                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                    data={medicineData || []}
                    columns={PRODUCT_TABLE_HEADER}
                    size="small"
                    editMedicine={true}
                    onClickEdit={handleEditClick}
                  />
                  <Stack direction="row" spacing={0.5} alignItems="center" marginTop={'5%'}>
                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>Total Amt.</Typography>
                      <TextField sx={{ width: '100%' }} name="total_amt" disabled />
                    </Stack>

                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 0.8 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>Dis%</Typography>
                      <TextField sx={{ width: '100%' }} name="dis_per" />
                    </Stack>

                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>Dis Amt</Typography>
                      <TextField sx={{ width: '100%' }} name="dis_amount" disabled />
                    </Stack>

                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>Bill Amt</Typography>
                      <TextField sx={{ width: '100%' }} name="bill_amount" inputRef={billAmountRef} />
                    </Stack>
                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>GST</Typography>
                      <TextField sx={{ width: '100%' }} name="gst" inputRef={gstAmountRef} disabled />
                    </Stack>
                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>CGST</Typography>
                      <TextField sx={{ width: '100%' }} name="cgst" disabled inputRef={cgstAmountRef} />
                    </Stack>
                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>SGST</Typography>
                      <TextField sx={{ width: '100%' }} name="sgst" disabled inputRef={sgstAmountRef} />
                    </Stack>
                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>1. Recpt.</Typography>
                      <TextField sx={{ width: '100%' }} name="recpt_1" />
                    </Stack>

                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>2. Recpt.</Typography>
                      <TextField sx={{ width: '100%' }} name="recpt_2" />
                    </Stack>

                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>Total</Typography>
                      <TextField disabled sx={{ width: '100%' }} name="total_recpt" />
                    </Stack>

                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>Balance</Typography>
                      <TextField disabled sx={{ width: '100%' }} name="balance" />
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Indent Medicine Return Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search By Issue No."
            variant="outlined"
            value={indentMedicineInput}
            onChange={handleIndentMedicineQuery}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={POS_HEADER}
          data={originalMedicineIssue || []}
          loading={posData.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
      <Dialog
        open={addDetailsDialogue}
        onClose={() => setAddDetailsDialogOpen(false)}
        PaperProps={{ sx: { width: '70%', height: '70vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <MedicineEditForm
          onClose={() => setAddDetailsDialogOpen(false)}
          onAdd={onDetailAddHandler}
          stockProduct={stockProduct}
          filteredServiceList={filteredServiceList}
          setFilteredServiceList={setFilteredServiceList}
        />
      </Dialog>
    </>
  );
};
